import { useLazyQuery } from "@apollo/client/react"; import './imprimirVisitaGrilla.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';

import fileDownload from 'js-file-download';
import { GET_IMPRIMIR_DOCUMENTOS } from '../../../data/graphQL/queries/ImprimirVisita/getImprimirVisitaDetalle';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { ResumenIngresoPrint } from '../../ResumenIngresoDetalle/components/ResumenIngresoPrint';

export const ImprimirVisitaGrillaHeader = ({
  allowedWrite,
  documentosSeleccionados,
  setPrintLoading
}) => {
  const [loadingRI, setLoadingRI] = useState(false);

  const [getPrintDocumento, { data: docData, loading: printDocumentoLoading }] = useLazyQuery(GET_IMPRIMIR_DOCUMENTOS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!docData) return;
    if (docData.imprimirDocumentos.success) {
      const arr = new Uint8Array(docData.imprimirDocumentos.valorEsperado);
      const documento = new Blob([arr], { type: 'application/pdf' });
      const fileName = 'Documentos-' + moment().format("DD/MM/YYYY HH:mm:ss") + '.pdf';
      fileDownload(documento, fileName);
    } else {
      toast.error("No fue posible generar el documento.");
    }
    setPrintLoading(false);
  }, [docData]);

  const getDocsVisitas = async (listaVisitas) => {
    const listaDocs = [];
    if (listaVisitas.length > 0) {
      // No docs RI
      const documentos = listaVisitas.filter((x) => x.idTipoDocumento != 3);
      documentos.map((nodo) => {
        listaDocs.push({
          idDocumento: nodo.idVisita,
          idTipoDocumento: nodo.idTipoDocumento,
          contenido: '',
          soloCP: false
        });
      });
      // RI
      const documentosRI = await handleGenerarPdf(listaVisitas.filter((x) => x.idTipoDocumento == 3));
      documentosRI.forEach((nodo) => {
        listaDocs.push({
          idDocumento: nodo.id,
          idTipoDocumento: 3,
          contenido: nodo.html,
          soloCP: nodo.soloCP
        });
      });
    }

    return listaDocs;
  };

  const printValid = () => {
    if (documentosSeleccionados.length === 0) {
      toast.error("Debe seleccionar al menos un registro para imprimir.");
      return false;
    }

    return true;
  };

  const handleImprimir = async () => {
    if (printValid() && !printDocumentoLoading && !loadingRI) {
      setPrintLoading(true);
      getPrintDocumento({ variables: { documentos: await getDocsVisitas(documentosSeleccionados) } });
    }
  };

  const [idActual, setIdActual] = useState(null);
  const [resolverActual, setResolverActual] = useState(null);

  const handleReady = (html) => {
    // Se ejecuta cuando el hijo terminó de renderizar
    resolverActual?.(html);
  };

  const generarHtmlsSeleccionados = async (seleccionados) => {
    const resultados = [];

    for (const doc of seleccionados) {
      const html = await new Promise((resolve) => {
        setResolverActual(() => resolve);
        setIdActual(doc.idVisita);
      });

      resultados.push({ id: doc.idVisita, html, soloCP: document.getElementById('riSoloCP').innerHTML == "0" ? false : true });
    }
    setLoadingRI(false);
    return resultados;
  };

  const handleGenerarPdf = async (listaDocumentos) => {
    setLoadingRI(true);
    const htmls = await generarHtmlsSeleccionados(listaDocumentos);
    return htmls;
  };

  return (
    <>
      <div className='top-buttons'>
        <CustomButton
          isLoading={printDocumentoLoading || loadingRI}
          disabled={
            documentosSeleccionados == null || documentosSeleccionados.length == 0
          }
          onClick={handleImprimir}
          variant="outlined">

          Imprimir
        </CustomButton>
      </div>
      <div style={{ display: "none" }}>
        {idActual &&
          <ResumenIngresoPrint
            idDatosGeneralesRI={idActual}
            onReady={handleReady} />

        }
      </div>
    </>);

};